/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import {getCookie, getMode, getSetting, navigate, removeCookie, setCookie,} from '@dvrd/dvr-controls';
import {CookieAttributes} from "js-cookie";
import User from "../models/userModel";
import {ContextShape} from "./interfaces";
import {deleteFromLocal, saveToLocal} from "./storageUtil";
import {setJWT} from "./jwtUtil";
import {ADMIN_USERS_ROUTE, SELECTED_ACCOUNT_KEY} from "./constants";

let adminJwt: string | null = null;
let cookieName: string = 'bolmate_admin_jwt';
const mode = getMode();
if(mode !== 'prod') cookieName += `_${mode}`;

export const setAdminJwt = (jwt: string | null) => {
    adminJwt = jwt;
    const args: CookieAttributes = getCookieArgs();
    if (!jwt) removeCookie(cookieName, args);
    else setCookie(cookieName, jwt, args);
}

export const getAdminJwt = (): string | null => {
    if (!adminJwt) adminJwt = getCookie(cookieName) || null;
    return adminJwt;
};

export const hasAdminLogin = (): boolean => adminJwt !== null;

export const onAdminLogout = (context: ContextShape): boolean => {
    const adminJwt = getAdminJwt();
    if (adminJwt) {
        setJWT(adminJwt, 30);
        deleteFromLocal(SELECTED_ACCOUNT_KEY);
        User.get(null, (user: User | null) => {
            if (user) {
                if (user.accounts.length)
                    saveToLocal(SELECTED_ACCOUNT_KEY, user.accounts[0].id);
                context.onChangeContext({
                    user,
                    accounts: user.accounts,
                    account: user.accounts.length ? user.accounts[0] : null,
                }, () => {
                    navigate(ADMIN_USERS_ROUTE);
                });
            } else navigate('/inloggen');
        });
        setAdminJwt(null);
        return true;
    }
    return false;
}

const getCookieArgs = (): CookieAttributes => {
    let args: CookieAttributes = {expires: 30, sameSite: 'strict'};
    if (getSetting('mode') !== 'dev') {
        args.secure = true;
        args.sameSite = 'strict';
    }
    return args;
}